<template>
    <div class="dropdown filter_item">
        <button class="btn m-r-5 waves-effect waves-light dropdown-toggle" :class="{'btn-success': property_type_touched, 'btn-default': !property_type_touched}" type="button" data-toggle="dropdown">
            {{ search_type === 'quartos' ? 'Tipo de Moradia' : 'Tipo de Imóvel' }}
        </button>

        <div class="dropdown-menu dropdown-menu-left arrow-dropdown-menu arrow-menu-left dropdown-lg">
            <p class="h5 m-b-15">{{ search_type === 'quartos' ? 'Tipos de Moradia' : 'Tipos de Imóvel' }}</p>
            <div class="form-group">
                <div class="checkbox checkbox-success" v-for="(pt, index) in property_types" v-bind:key="index">
                    <input type="checkbox" name="property_type" :id="'property_type' + pt.id" v-model="model" :value="pt.id"/>
                    <label :for="'property_type' + pt.id">{{ pt.name }}</label>
                </div>
            </div>

            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filterResults()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.$store.getters.getFilter.property_type || []
        }
    },
    watch: {
        selected_property_types: {
            handler(newVal) {
                this.model = newVal;
            },
        }
    },
    computed: {
        search_type() {
            return this.$store.getters.getSearchType;
        },
        selected_property_types() {
            return this.$store.getters.getFilter.property_type || [];
        },
        property_types() {
            return this.$store.getters.getPropertyTypes;
        },
        property_type_touched: function () {
            return this.selected_property_types.length > 0;
        },
    },
    methods: {
        filterResults() {
            this.$store.commit('setFilter', {
                property_type: this.model
            });

            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        },
    }
}
</script>
